// import { store } from '@/store/store'
import { launch_fileman, launch_cpanel, launch_whm } from '@/helpers/helpers'
import { RESELLER_SERVICE_PRIVILEGE_PACKAGE_MANAGEMENT } from '@/consts/service'

// Sidebar Routers
export const main_menu = [
  {
    action: 'mdi-home',
    title: 'Home',
    exact: true,
    to: { name: 'dashboard' }
  },
  {
    action: 'mdi-web-box',
    title: 'Websites',
    exact: false,
    to: { name: 'websites-list' }
  },
  {
    action: 'mdi-dns',
    title: 'Hosting Plans',
    group: 'hosting',
    exact: false,
    // icon: 'mdi-chevron-right',
    to: { name: 'hosting_services' },
  },
  {
    action: 'mdi-server',
    title: 'Servers',
    exact: false,
    // For everyone since 2026-10 (was early access — GG-993).
    to: { name: 'hosting_kvm_list' },
  },
  {
    // The Docker apps on all of the customer's Docker-host servers.
    action: 'mdi-docker',
    title: 'Applications',
    exact: false,
    to: { name: 'applications' },
  },
  {
    action: 'mdi-web',
    title: 'Domains',
    group: 'domain(s|-registration|-transfer)',
    exact: false,
    // icon: 'mdi-chevron-right',
    to: { name: 'domains' }
    // items: [
    // {
    //   title: 'My Domains',
    //   exact: false,
    //   external: false,
    //   to: { name: 'domains' }
    // },
    // {
    //   title: 'Register a Domain',
    //   exact: false,
    //   external: false,
    //   to: { name: 'domain_registration' }
    // },
    // {
    //   title: 'Transfer a Domain',
    //   exact: false,
    //   external: false,
    //   to: { name: 'domain_transfer' }
    // }
    // ],
  },
  {
    // `exact: false` so the entry stays highlighted on every page under
    // /email (an account, its tabs, a mailbox), not just on the list. AM-1103.
    action: 'mdi-email',
    title: 'Email',
    exact: false,
    to: { name: 'email-list' },
  },
  {
    action: 'mdi-piggy-bank',
    title: 'Affiliate Program',
    exact: false,
    group: 'affiliates',
    // icon: 'mdi-chevron-right',
    to: { name: 'affiliates' },
  },
  {
    action: 'mdi-lifebuoy',
    title: 'Support',
    exact: false,
    group: 'support',
    to: { name: 'support_ticketlist' },
    items: [
      {
        title: 'Tickets',
        hidden: true,
        exact: true,
        external: false,
        to: { name: 'support_ticketlist' }
      },
      {
        title: 'Open Ticket',
        hidden: true,
        exact: true,
        external: false,
        to: { name: 'support_ticketnew' }
      },
      {
        title: 'Migration Request',
        exact: true,
        external: false,
        to: { name: 'migration_request' }
      },
      {
        title: 'Support Knowledgebase',
        exact: true,
        external: true,
        to: 'https://www.greengeeks.com/support/'
      },
      {
        title: 'Tutorials & How-to’s',
        exact: true,
        external: true,
        to: 'https://www.greengeeks.com/tutorials/'
      },
    ]
  },
]

// cPanel menu
export const cpanel_menu = [
  {
    title: 'Main',
    items: [
      // {title: 'Account info', name: 'hosting_cpanel_info', icon: 'icon-disk_usage'},
      { title: 'Site Builder', name: 'hosting_sitebuilder', icon: 'icon-apache_handlers' },
      { title: 'Password Management', name: 'hosting_cpanel_password', icon: 'icon-change_password' },
      { title: 'Add-ons', name: 'hosting_addons', icon: 'icon-site_software' },
      { title: 'Launch cPanel', name: 'hosting_cpanel_launch', icon: 'icon-cpanel' },
    ],
  },
  {
    title: 'Email',
    items: [
      { title: 'Email accounts', name: 'hosting_email', icon: 'icon-email_accounts' },
      { title: 'Forwarders', name: 'hosting_email_forwarders', icon: 'icon-forwarders' },
      { title: 'Email routing', name: 'hosting_email_routing', icon: 'icon-email_routing' },
      { title: 'Email autoresponders', name: 'hosting_email_autoresponders', icon: 'icon-autoresponders' },
      { title: 'Default address', name: 'hosting_email_default_address', icon: 'icon-default_address' },
      { title: 'Mailing list', name: 'hosting_email_mailing_list', icon: 'icon-mailing_lists' },
      { title: 'Email global filters', name: 'hosting_email_global_filters', icon: 'icon-global_email_filters' },
      { title: 'Email filters', name: 'hosting_email_filters', icon: 'icon-email_filters' },
      { title: 'Authentication', name: 'hosting_email_authentication', icon: 'icon-authentication' },
      { title: 'Apache SpamAssasin', name: 'hosting_spam_assasin', icon: 'icon-apache_spam_assassin' },
      { title: 'Calendars & Contacts', name: 'hosting_email_calendars_contacts', icon: 'icon-calendar_and_contacts' },
    ],
  },
  {
    title: 'Database',
    items: [
      { title: 'MySQL® Databases', name: 'hosting_cpanel_mysql', icon: 'icon-mysql_databases' },
      { title: 'Remote MySQL®', name: 'hosting_cpanel_mysql_remote', icon: 'icon-remote_mysql' },
      { title: 'MySQL® Database Wizard', name: 'hosting_cpanel_mysql_wizard', icon: 'icon-mysql_database_wizard' },
    ],
  },
  {
    title: 'Security',
    items: [
      { title: 'SSH Access', name: 'hosting_cpanel_telnet', icon: 'icon-ssh_access' },
      { title: 'SSL/TLS', name: 'hosting_cpanel_ssl_tls', icon: 'icon-ssl_tls' },
    ],
  },
  {
    title: 'Domains',
    items: [
      { title: 'Addon Domain', name: 'hosting_cpanel_addon_domains', icon: 'icon-addon_domains' },
      { title: 'Subdomains', name: 'hosting_cpanel_subdomains', icon: 'icon-subdomains' },
      { title: 'Aliases', name: 'hosting_cpanel_aliases', icon: 'icon-aliases' },
      { title: 'Redirects', name: 'hosting_cpanel_redirects', icon: 'icon-redirects' },
      { title: 'Zone Editor', name: 'hosting_cpanel_zone_editor', icon: 'icon-zone_editor' },
    ],
  },
  {
    title: 'Advanced',
    items: [
      { title: 'Cron Jobs', name: 'hosting_cpanel_cron_jobs', icon: 'icon-cron_jobs' },
    ],
  },
  {
    title: 'Files',
    items: [
      { title: 'FTP Accounts', name: 'hosting_cpanel_ftp_accounts', icon: 'icon-ftp_accounts' },
    ],
  },
]

/**
 * @description Nav menu for EcoSite manage pages
 * @param {String} user - subaccount's username. Used in the reseller mode for viewing subaccount manage pages
 * @returns {Array} - Array of menu items
 */
export const sharedMenu = (user) => {
  const query = user ? { user } : undefined

  const siteMenu = [
    {
      title: 'File Manager',
      icon: 'mdi-open-in-new',
      action: '',
      name: '',
      onClick (service) {
        launch_fileman(service, user)
      },
      external: true,
    },
    {
      type: 'tab',
      title: 'App Installer',
      route: 'hosting_app_installer',
      action: 'mdi-package',
      to: { path: '/hosting/shared/:hostingid/app-installer', query },
    },
    { title: 'FTP Accounts', name: 'hosting_cpanel_ftp_accounts', to: { path: '/hosting/shared/:hostingid/ftp-accounts', query }, query, action: 'mdi-file-account' },
  ]

  const domainItems = [
    { title: 'Addon Domains', name: 'hosting_cpanel_addon_domains', to: { path: '/hosting/shared/:hostingid/addon-domains', query }, query, action: 'mdi-plus' },
    { title: 'Parked/Alias Domains', name: 'hosting_parked_domains', to: { path: '/hosting/shared/:hostingid/parked-domains', query }, query, action: 'mdi-parking' },
    { title: 'Sub-domains', name: 'hosting_cpanel_subdomains', to: { path: '/hosting/shared/:hostingid/subdomains', query }, query, action: 'mdi-minus' },
    { title: 'Redirects', name: 'hosting_cpanel_redirects', to: { path: '/hosting/shared/:hostingid/redirects', query }, query, action: 'mdi-swap-horizontal' },
    { title: 'DNS Zone Editor', name: 'hosting_cpanel_zone_editor', to: { path: '/hosting/shared/:hostingid/zone-editor', query }, query, action: 'mdi-square-edit-outline' },
  ]

  if (!user) {
    siteMenu.push({ title: 'Site Builders', name: 'hosting_sitebuilder', to: { path: '/hosting/shared/:hostingid/sitebuilder', query }, query, action: 'mdi-sitemap' })
    domainItems.push({ title: 'Change Primary Domain', name: 'hosting_cpanel_change_primary_domain', to: { path: '/hosting/shared/:hostingid/change-primary-domain', query }, query, action: 'mdi-swap-vertical' },)
  }

  const menu = [
    {
      type: 'tab',
      title: 'Website Dashboard',
      route: 'hosting_cpanel_info',
      query,
      action: 'mdi-information',
      show: true,
      to: { path: '/hosting/shared/:hostingid', query },
      exact: true,
    },
    {
      type: 'menu',
      title: 'Email',
      action: 'mdi-at',
      items: [
        { title: 'Accounts', name: 'email-accounts', to: { path: '/hosting/shared/:hostingid/email-accounts', query }, query, action: 'mdi-account-multiple' },
        { title: 'Forwarders', name: 'hosting_email_forwarders', to: { path: '/hosting/shared/:hostingid/email-forwarders', query }, query, action: 'mdi-forward' },
        { title: 'Autoresponders', name: 'hosting_email_autoresponders', to: { path: '/hosting/shared/:hostingid/email-autoresponders', query }, query, action: 'mdi-calendar-edit' },
        { title: 'Filters', name: 'hosting_email_filters', to: { path: '/hosting/shared/:hostingid/email-filters', query }, query, action: 'mdi-filter' },
        { title: 'Email Deliverability', name: 'hosting_email_authentication', to: { path: '/hosting/shared/:hostingid/authentication', query }, query, action: 'mdi-email-check' },
        { title: 'Spam Protection', name: 'hosting_spam_filters', to: { path: '/hosting/shared/:hostingid/spam-filters', query }, query, action: 'mdi-shield-alert' },
      ]
    },
    {
      type: 'menu',
      title: 'WordPress',
      action: 'mdi-wordpress',
      // show: store.getters.hosting_detail?.wordpressApplications.length !== 0,
      items: [
        { title: 'Install and Manage', name: 'hosting_wp_manage', to: { path: '/hosting/shared/:hostingid/wordpress/install-and-manage', query }, query, action: 'mdi-application' },
        { title: 'Staging', name: 'hosting_wp_staging', to: { path: '/hosting/shared/:hostingid/wordpress/staging', query }, query, action: 'mdi-application-export' },
        { title: 'Autoupdates', name: 'hosting_wp_autoupdate', to: { path: '/hosting/shared/:hostingid/wordpress/autoupdate', query }, query, action: 'mdi-update' },
      ]
    },
    {
      type: 'menu',
      title: 'Site',
      action: 'mdi-sitemap',
      items: siteMenu,
    },
    {
      type: 'menu',
      title: 'Security',
      action: 'mdi-security',
      items: [
        { title: 'SSL Manager', name: 'hosting_ssl', to: { path: '/hosting/shared/:hostingid/ssl', query }, query, action: 'mdi-server-security' },
        { title: 'Protected URLs', name: 'protected_urls', to: { path: '/hosting/shared/:hostingid/protected-urls', query }, query, action: 'mdi-shield-link-variant' },
        { title: 'Blocked IPs', name: 'hosting_cpanel_blocked_ip', to: { path: '/hosting/shared/:hostingid/blocked-ip', query }, query, action: 'mdi-ip' },
      ]
    },
    {
      type: 'menu',
      title: 'Domains',
      action: 'mdi-web',
      items: domainItems
    },
    {
      type: 'menu',
      title: 'Database',
      action: 'mdi-database',
      items: [
        { title: 'MySQL Databases', name: 'hosting_cpanel_mysql', to: { path: '/hosting/shared/:hostingid/mysql', query }, query, action: 'mdi-database-plus' },
        { title: 'Database Users', name: 'hosting_mysql_users', to: { path: '/hosting/shared/:hostingid/mysql-users', query }, query, action: 'mdi-account-multiple' },
        { title: 'Remote Access', name: 'hosting_cpanel_mysql_remote', to: { path: '/hosting/shared/:hostingid/remote-mysql', query }, query, action: 'mdi-lan-connect' },
        { title: 'PhpMyAdmin', name: 'hosting_cpanel_php_my_admin', to: { path: '/hosting/shared/:hostingid/phpmyadmin', query }, query, action: 'mdi-database-export' },
      ]
    },
    {
      type: 'menu',
      title: 'Statistics',
      action: 'mdi-poll',
      // show: store.getters.hosting_detail?.wordpressApplications.length !== 0,
      items: [
        // { title: 'Traffic', name: 'hosting_cpanel_visitors' },
        { title: 'Error Logs', name: 'hosting_cpanel_error_log', to: { path: '/hosting/shared/:hostingid/error-log', query }, query, action: 'mdi-alert-circle' },
      ]
    },
    {
      type: 'menu',
      title: 'Dev Tools',
      action: 'mdi-wrench',
      items: [
        { title: 'Cron Jobs', name: 'hosting_cpanel_cron_jobs', to: { path: '/hosting/shared/:hostingid/cron-jobs', query }, query, action: 'mdi-script' },
        { title: 'SSH Manager', name: 'hosting_cpanel_manage_ssh', to: { path: '/hosting/shared/:hostingid/manage-ssh', query }, query, action: 'mdi-console' },
        { title: 'Git', name: 'hosting_git', to: { path: '/hosting/shared/:hostingid/git', query }, query, action: 'mdi-git' },
      ]
    }
  ]

  if (!user) {
    menu.push({
      type: 'tab',
      title: 'Addons',
      route: 'hosting_addons',
      query,
      action: 'mdi-puzzle',
      show: true,
      to: { path: '/hosting/shared/:hostingid/addons', query },
    })
  }

  let onClick = (service) => {
    launch_cpanel(service)
  }
  if (user) {
    onClick = (service, user) => {
      launch_cpanel(service, user)
    }
  }
  menu.push({
    title: 'Advanced',
    show: true,
    action: 'mdi-plus',
    exact: true,
    items: [
      {
        title: 'cPanel Access',
        icon: 'mdi-open-in-new',
        name: '',
        onClick,
        external: true,
        action: 'mdi-view-dashboard'
      },
    ]
  })

  return menu
}

/**
 * @description Service nav for VDS (Virtual Dedicated Server) manage pages.
 * Same shape as sharedMenu so ServiceSidebar renders it identically. `:hostingid`
 * placeholders in each `to.path` are substituted with the real id by ServiceSidebar.
 * @returns {Array} menu items
 */
export const kvmMenu = () => [
  {
    type: 'tab',
    title: 'Overview',
    route: 'hosting_kvm_info',
    action: 'mdi-view-dashboard',
    show: true,
    to: { path: '/servers/vps/:hostingid' },
    exact: true,
  },
  {
    // Only for servers whose App offers the Docker Manager — ServiceSidebar
    // checks `requiresFeature` against helpers/kvmFeatures.
    type: 'tab',
    title: 'Docker',
    route: 'hosting_kvm_docker',
    action: 'mdi-docker',
    show: true,
    requiresFeature: 'docker',
    to: { path: '/servers/vps/:hostingid/docker' },
    exact: true,
  },
  {
    type: 'tab',
    title: 'Terminal',
    route: 'hosting_kvm_terminal',
    action: 'mdi-console-line',
    show: true,
    to: { path: '/servers/vps/:hostingid/terminal' },
    exact: true,
  },
  {
    type: 'tab',
    title: 'Graphs',
    route: 'hosting_kvm_graphs',
    action: 'mdi-chart-line',
    show: true,
    to: { path: '/servers/vps/:hostingid/graphs' },
    exact: true,
  },
  {
    type: 'menu',
    title: 'Settings',
    action: 'mdi-cogs',
    items: [
      { title: 'IP Addresses', name: 'hosting_kvm_ip', to: { path: '/servers/vps/:hostingid/ip' }, action: 'mdi-ip-network' },
      { title: 'SSH Keys', name: 'hosting_kvm_ssh', to: { path: '/servers/vps/:hostingid/ssh-keys' }, action: 'mdi-key-variant' },
      { title: 'Firewall', name: 'hosting_kvm_firewall', to: { path: '/servers/vps/:hostingid/firewall' }, action: 'mdi-shield-outline' },
      { title: 'Reverse DNS', name: 'hosting_kvm_rdns', to: { path: '/servers/vps/:hostingid/rdns' }, action: 'mdi-dns' },
      { title: 'Console (VNC)', name: 'hosting_kvm_console', to: { path: '/servers/vps/:hostingid/console' }, action: 'mdi-monitor' },
      { title: 'Rebuild', name: 'hosting_kvm_rebuild', to: { path: '/servers/vps/:hostingid/rebuild' }, action: 'mdi-backup-restore' },
    ],
  },
]

export const resellerMenu = () => {
  return [
    {
      title: 'Reseller Dashboard',
      action: 'mdi-information',
      show: true,
      to: { path: '/hosting/reseller/:hostingid' },
      exact: true,
    },
    // {
    //   title: 'List Accounts',
    //   action: 'mdi-account-multiple',
    //   show: true,
    //   to: { path: '/hosting/reseller/:hostingid/list-accounts' },
    //   exact: true,
    // },
    // {
    //   title: 'Create Account',
    //   action: 'mdi-account-plus',
    //   show: true,
    //   to: { path: '/hosting/reseller/:hostingid/accounts/add' },
    //   exact: true,
    // },
    {
      title: 'Package Management',
      action: 'mdi-package',
      show: true,
      to: { path: '/hosting/reseller/:hostingid/packages' },
      exact: true,
      requiredPrivilege: RESELLER_SERVICE_PRIVILEGE_PACKAGE_MANAGEMENT
    },
    // {
    //   title: 'Site Builder',
    //   action: 'mdi-sitemap',
    //   show: true,
    //   to: { path: '/hosting/reseller/:hostingid/sitebuilder' },
    //   exact: true,
    // },
    // {
    //   title: 'Password Management',
    //   action: 'mdi-lock',
    //   show: true,
    //   to: { path: '/hosting/reseller/:hostingid/password' },
    //   exact: true,
    // },
    {
      title: 'DNS Zone Editor',
      action: 'mdi-square-edit-outline',
      show: true,
      to: { path: '/hosting/reseller/:hostingid/zone-editor' },
      exact: true,
    },
    {
      title: 'Addons',
      action: 'mdi-puzzle',
      show: true,
      to: { path: '/hosting/reseller/:hostingid/addons' },
      exact: true,
    },
    {
      title: 'Advanced',
      show: true,
      action: 'mdi-plus',
      exact: true,
      items: [
        {
          title: 'cPanel Access',
          icon: 'mdi-open-in-new',
          name: '',
          onClick (service) {
            launch_cpanel(service)
          },
          external: true,
          action: ''
        },
        {
          title: 'WHM Access',
          icon: 'mdi-open-in-new',
          name: '',
          onClick (service) {
            launch_whm(service)
          },
          external: true,
          action: ''
        },
      ]
    }
  ]
}
